import { Icon, Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Wrapper = styled.div`
  margin-left: 10px;
  margin-bottom: 2px;
  display: flex;
  align-items: baseline;
  color: ${({ theme }) => theme["@gray-60"]};
  text-transform: uppercase;

  p {
    font-size: 9px;
    margin-left: 5px;
    margin-bottom: 0px;
  }
`;

const Content = styled.div`
  width: 180px;
  display: flex;
  justify-content: center;
`;

function ExcludingFilterInfo() {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <div>
        <Tooltip
          title={
            <div style={{ display: "flex" }}>
              <Content>
                <Icon
                  style={{ fontSize: 20, marginTop: 10 }}
                  type="info-circle"
                />
              </Content>
              <div style={{ padding: 5 }}>
                <div style={{ textTransform: "uppercase" }}>
                  {t("opportunity:candidates.excludingFilters.title")}
                </div>
                <div>{t("opportunity:candidates.excludingFilters.help")}</div>
              </div>
            </div>
          }
        >
          <Icon style={{ fontSize: 12 }} type="info-circle" />
        </Tooltip>
      </div>
      <p>{t("opportunity:candidates.excludingFilters.title")}</p>
    </Wrapper>
  );
}

export default ExcludingFilterInfo;
